module.exports = {"ManagementDecisions":"تصمیمات مدیریتی"}